//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { submitQuestionList } from '@/api';
export default {
  props: {
    list: {
      type: Array,
      default: null,
    },
    questionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      question: 0,
      answerKey: {
        0: 'A',
        1: 'B',
        2: 'C',
        3: 'D',
        4: 'E',
        5: 'F',
      },
    };
  },
  methods: {
    ...mapActions('user', ['updateUserInfoKyc']),
    /**
     * @description 选择题目
     * @param { object } item 操作对象
     * @param { number } index 当前索引
     */
    handleClick(item, childItem) {
      item.answer = childItem.id;
      if (this.question < this.list.length - 1) {
        this.question++;
      } else {
        this.submitList();
      }
    },
    /**
     * @description 提交列表
     */
    async submitList() {
      const arr = this.list.map(item => {
        return {
          questionId: item.id,
          optionIds: [item.answer],
        };
      });
      const data = await this.$axios(submitQuestionList(this.questionId, arr));
      if (data.result) {
        const { evaluationType, description, expireTimestamp, id } =
          data.result;
        this.updateUserInfoKyc({
          svipInvestor: true,
        });
        this.$emit('submitSuccess', {
          type: evaluationType,
          desc: description,
          expireTimestamp,
          id,
        });
      }
    },
  },
};
